import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import { Warning } from '../../helpers/icon-dictionary';
import Button from '../button/index';
import { DENIM } from '../button/variants';
import styles from './index.scss';
import SvgIcon from '../svg-icon/svg-icon';
import messages from './messages';

class MaxGroupError extends Component {
    constructor(props) {
        super(props);
        this.handleOnClose = this.handleOnClose.bind(this);
    }

    handleOnClose = () => {
        const { closeAddGroup } = this.props;
        closeAddGroup();
    }

    render() {
        const { intl } = this.props;
        return (
            <div>
                <div className={styles.addGroupComponent}>
                    <div className={styles.icon}>
                        <SvgIcon icon={Warning} />
                    </div>
                    <div className={styles.header}>
                        {intl.formatMessage(messages.maxGroupErrorTitle)}
                    </div>
                    <div className={styles.description}>
                        {intl.formatMessage(messages.maxGroupErrorLongDesc)}
                    </div>
                    <Button
                        handleOnClick={this.handleOnClose}
                        label={intl.formatMessage(messages.okBtn)}
                        variant={DENIM} />
                </div>
            </div>
        );
    }
}

MaxGroupError.propTypes = {
    closeAddGroup: PropTypes.func,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(styles)(MaxGroupError));




// WEBPACK FOOTER //
// ./app/components/add-group/max-group-error.js